/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { CacheType, createObservableDataAction, IAction, IActionContext, IActionInput } from '@msdyn365-commerce/core';
import { createContactAsync } from '../generated/DataActionExtension.g';
import { IDXC_ContactResponse } from '../generated/DataServiceEntities.g';

/**
 * SubmitContactFormDataActionInput Input Action
 */

export class SubmitContactFormDataActionInput implements IActionInput {
    public name: string;
    public emailAddress: string;
    public phoneNumber: string;
    public country: string;
    public city: string;
    public reasonForEnquiry: string;
    public message: string;

    // Construct the input needed to run the action
    constructor(name: string, emailAddress: string, phoneNumber: string, country: string, city: string, reasonForEnquiry: string, message: string) {
        this.name = name;
        this.emailAddress = emailAddress;
        this.phoneNumber = phoneNumber;
        this.country = country;
        this.city = city;
        this.reasonForEnquiry = reasonForEnquiry;
        this.message = message;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => 'ContactForm2020';
    public getCacheObjectType = () => 'ContactForm';
    public dataCacheType = (): CacheType => 'request';
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: SubmitContactFormDataActionInput): IActionInput => {
    return args;
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function submitContactFormAction(
    input: SubmitContactFormDataActionInput,
    ctx: IActionContext
): Promise<IDXC_ContactResponse> {
    // Input only needs token
    let result: IDXC_ContactResponse = { success: false };
    try {
        result = await createContactAsync({ callerContext: ctx }, input.name, input.emailAddress, input.phoneNumber, input.country, input.city, input.reasonForEnquiry, input.message);
    } catch (error) {
        console.log(error);
    }
    return Array.isArray(result) ? result[0] : result;
}

export const ISubmitContactFormDataActionAction = createObservableDataAction({
    action: <IAction<IDXC_ContactResponse>>submitContactFormAction,
    input: createInput
});